import { FunctionComponent, useEffect } from "react";
import ListFilterButton from "components/shared/ListFilterButton";
import useUrlBooleanFlags from "hooks/useUrlBooleanFlags";
import { useAppDispatch } from "components/shared/App";
import { setFlags } from "store/slices/query";

const LoanTableActions: FunctionComponent = function () {
  const dispatch = useAppDispatch();

  const {
    values: { solar },
    toggleValue,
  } = useUrlBooleanFlags(["solar"]);

  useEffect(() => {
    dispatch(
      setFlags([
        "loans",
        {
          solar,
        },
      ])
    );
  }, [solar]);

  return (
    <>
      <ListFilterButton
        id="solar-loans"
        active={solar}
        label="Solar loans"
        activeLabel="Not solar loans"
        onClick={() => {
          toggleValue("solar");
        }}
      />
    </>
  );
};

export default LoanTableActions;
